var exports = {
  "x": "x93eb46d8--a46941--button",
};

module.exports = exports;
